import type { ParsedQs } from 'qs'

export type ParsedQsValue = ParsedQs[keyof ParsedQs]

export const decodeQueryArray = (value: ParsedQsValue): string[] => {
  if (typeof value === 'string') {
    // oxlint-disable-next-line unicorn/prefer-includes
    if (value.indexOf(',') > -1) {
      return value.split(',').map(decodeURIComponent)
    }

    return [decodeURIComponent(value)]
  }

  if (value && Array.isArray(value)) {
    const stringValues: string[] = []

    value.forEach((item: ParsedQsValue) => {
      if (typeof item === 'string') {
        stringValues.push(item)
      }
    })

    return stringValues.map(decodeURIComponent)
  }

  return []
}
